import React from "react";
import '../../static/fonts.css';
import '../Components/Buttons/ButtonAll.css';
import './LayoutMain.css';
import FooterAll from "./FooterAll/FooterAll";
import HeaderAllGatsby from "./HeaderAll/HeaderAll";
import TopMenu from "./TopMenu/TopMenu";
import {Helmet} from "react-helmet";

function LayoutMain(props) {
    // console.log('title',props.title,'description',props.description,'keywords',props.keywords);
    return (
        <div className="LayoutMain ">
            <Helmet>
                <title>{props.title ? props.title[props.lang] : ''}</title>
                <meta name="description" content={props.description ? props.description[props.lang] : ''}/>
            </Helmet>
            <HeaderAllGatsby lang={props.lang} Active={props.Active} index={props.index}/>
            <TopMenu lang={props.lang} Active={props.Active}/>
            {props.children}
            <FooterAll lang={props.lang}/>
        </div>
    )}




export default LayoutMain